<template>
  <div class="container">
    <div class="column is-8 is-offset-2">
      <formulario-actualizacion></formulario-actualizacion>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormularioActualizacion from "@/components/FormularioActualizacion.vue";
export default {
  name: "inscripcion",
  components: {
    FormularioActualizacion
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters({
      estrategia: "getEstrategia"
    })
  },
  methods: {},
  mounted() {}
};
</script>

<style></style>
